import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import { addItemsToCart } from '../../actions/cartAction';
import { removeFromSaveForLater } from '../../actions/saveForLaterAction';
import { getDiscount } from '../../utils/functions';
import { Box, Button, Card, CardContent, CardMedia, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const SaveForLaterItem = ({ product, name, brand, price, cuttedPrice, image, stock, quantity, size }) => {

    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const theme = useTheme();

    const removeFromSaveForLaterHandler = (id, size) => {
        dispatch(removeFromSaveForLater(id, size));
        enqueueSnackbar("Removed From Save For Later", { variant: "success" });
    }

    const moveToCartHandler = (id, quantity, size) => {
        dispatch(addItemsToCart(id, quantity, size));
        removeFromSaveForLaterHandler(id, size);
        enqueueSnackbar("Product Added To Cart", { variant: "success" });
    }

    return (
        <Card sx={{ display: 'flex', mb: 2, bgcolor: 'background.default' }}>
            <CardMedia
                component="img"
                sx={{ width: 151, objectFit: 'contain', p: 2 }}
                image={image}
                alt={name}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                <CardContent>
                    <Typography component="div" variant="h6" noWrap={false}>
                        {name}
                    </Typography>
                    <Typography variant="subtitle2" color="text.secondary" component="div">
                        Brand: {brand}
                    </Typography>
                    {size && (
                        <Typography variant="subtitle2" color="text.secondary" component="div">
                            Size: {size}
                        </Typography>
                    )}
                    <Box sx={{ display: 'flex', alignItems: 'baseline', my: 1 }}>
                        <Typography variant="h5">₹{(price * quantity).toLocaleString()}</Typography>
                        <Typography variant="subtitle1" color="text.secondary" sx={{ textDecoration: 'line-through', mx: 1 }}>
                            ₹{(cuttedPrice * quantity).toLocaleString()}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: theme.palette.success.main }}>
                            {getDiscount(price, cuttedPrice)}% off
                        </Typography>
                    </Box>
                </CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>
                    <Button onClick={() => moveToCartHandler(product, quantity, size)} sx={{ ml: 1 }}>MOVE TO CART</Button>
                    <Button onClick={() => removeFromSaveForLaterHandler(product, size)} sx={{ color: theme.palette.error.main }}>REMOVE</Button>
                </Box>
            </Box>
        </Card>
    );
};

export default SaveForLaterItem;